import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes - matches existing cache strategy
      gcTime: 30 * 60 * 1000, // 30 minutes (formerly cacheTime)
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

// Query key factory for consistent cache invalidation
export const queryKeys = {
  // Recipes
  recipes: ['recipes'] as const,
  recipe: (id: string) => ['recipes', id] as const,
  userRecipes: ['recipes', 'user'] as const,
  publicRecipes: ['recipes', 'public'] as const,
  randomRecipes: ['recipes', 'random'] as const,
  search: (query: string) => ['search', query] as const,

  // Folders
  folders: ['folders'] as const,
  folder: (id: string) => ['folders', id] as const,
  folderRecipes: (id: string) => ['folders', id, 'recipes'] as const,
  recipeFolders: (recipeId: string) => ['recipes', recipeId, 'folders'] as const,

  // Collaboration
  collaborators: (folderId: string) => ['folders', folderId, 'collaborators'] as const,
  pendingInvitations: ['invitations', 'pending'] as const,

  // Ratings
  recipeRating: (recipeId: string) => ['recipes', recipeId, 'rating'] as const,

  // User
  currentUser: ['user'] as const,
  userProfile: ['user', 'profile'] as const,
  cookingActivity: ['user', 'cooking-activity'] as const,

  // Admin
  adminStats: ['admin', 'stats'] as const,
  adminRecipes: (page: number, status?: string) =>
    ['admin', 'recipes', { page, status }] as const,
};

export default queryClient;
